import moment from 'moment'

export const uuid = () => Math.floor( moment().valueOf() * Math.random() )